<div class="session-unavailable-page">
  <section
    class="session-unavailable"
    role="status"
    aria-labelledby="session-unavailable-title"
  >
    <i
      class="bi bi-cloud-slash session-unavailable__icon"
      aria-hidden="true"
    ></i>
    <h2
      #title
      id="session-unavailable-title"
      class="session-unavailable__title"
      tabindex="-1"
    >
      Can't reach VIVE right now, retrying…
    </h2>
    <button
      type="button"
      class="btn btn-primary"
      [disabled]="checking()"
      (click)="retry()"
    >
      @if (checking()) {
        <span
          class="spinner-border spinner-border-sm session-unavailable__spinner"
          aria-hidden="true"
        ></span>
      }
      Retry
    </button>
  </section>
</div>
